import React, { useState, useMemo } from "react";
import {
  Tabs,
  Empty,
  Input,
  Typography,
  Row,
  Col,
  Button,
  Pagination,
  Select,
} from "antd";
import {
  SearchOutlined,
  PlusOutlined,
  AppstoreOutlined,
} from "@ant-design/icons";
import { isMobile } from "@/utils/public";
import useBaseRequest from "@/hooks/useBaseRequest";
import { getModelType, getModelList } from "@/api/index";

function Home() {
   const [activeKey, setActiveKey] = useState("0");
  const [inputValue, setInputValue] = useState("");
  const [inputCache, setInputCache] = useState("");
  const [page, setPage] = useState(1);
  const [size, setSize] = useState(10);
  const [current, setCurrent] = useState(1);
  const [total, setTotal] = useState(0);
  const [deploymentType, setDeploymentType] = useState(undefined);
  const isMob = isMobile();

  return (
    <>
      <div className={`${isMob ? "m-zdSearchContent" : "zdSearchContent"}`}>
        <div className="content">
          {isMob ? (
            <>
              <div className="m-search">
                <Row gutter={[16, 16]}>
                  <Col span={24}>
                    <Input
                      value={inputValue}
                      onChange={(e) => {
                        // setInputValue(e.target.value)
                      }}
                      onKeyDown={(e) => {
                        if (e.key === "Enter") {
                          // runSearch(inputValue)
                        }
                      }}
                      suffix={
                        <SearchOutlined
                          style={{ fontSize: 16, color: "#1677ff" }}
                        />
                      }
                      placeholder="搜索模型"
                    />
                  </Col>
                  <Col span={24}>
                    <Button type="primary">搜索</Button>
                  </Col>
                </Row>
              </div>
            </>
          ) : (
            <div className="pcSearch">
              <Row gutter={[16, 16]}>
                <Col span={12}>
                  <Input
                    value={inputValue}
                    onChange={(e) => {
                      setInputValue(e.target.value);
                    }}
                    // onKeyDown={(e) => {
                    //     if (e.key === "Enter") {
                    //         setInputValue(e.target.value)
                    //     }
                    // }}
                    suffix={
                      <SearchOutlined
                        style={{ fontSize: 16, color: "#1677ff" }}
                      />
                    }
                    placeholder="搜索模型"
                  />
                </Col>
              </Row>
            </div>
          )}

          <Tabs 
             style={{
              height: "100%",
            }}
            type="card"
            key={"mcp"}
            items={[]}
              tabBarGutter={15}
            activeKey={activeKey}
            onChange={(activeKey) => {
              setActiveKey(activeKey);
            }}
            tabBarExtraContent={{
              right: isMob ? undefined : (
                <div
                  style={{
                    width: "300px",
                  }}
                ></div>
              ),
            }}
          
          />
        </div>
      </div>
    </>
  );
}

export default Home;
